import { createReducer, on } from '@ngrx/store';
import { initialState } from '../auth.state';

import * as actions from './registration.actions';
import { ContinueWithVerificationUi } from '@ory/client';

export const authRegistrationReducer = createReducer(
  initialState,

  on(actions.RequireRegistration, (state, { postLoginRoute }) => ({
    ...state,
    postLoginRoute,
  })),

  on(actions.RequestBeginRegistrationFlow, (state) => ({ ...state, loading: true })),

  on(actions.SuccessBeginRegistrationFlow, (state, { flow }) => ({
    ...state,
    loading: false,
    registrationFlow: flow,
  })),

  on(actions.FailBeginRegistrationFlow, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(actions.RequestCompleteRegistrationFlow, (state) => ({ ...state, loading: true })),
  on(actions.SuccessCompleteRegistrationFlow, (state, { response }) => ({
    ...state,
    loading: false,
    registrationFlow: 'complete' as 'complete',
    verificationFlow: response.continue_with
      ? (<ContinueWithVerificationUi>response.continue_with[0])?.flow
      : undefined,
    auth: {
      session: response.session,
      userId: response.session?.identity?.metadata_public['ca_member_id'],
    },
  })),

  on(actions.FailCompleteRegistrationFlow, (state, { response }) => ({
    ...state,
    loading: false,
    registrationFlow: response,
  }))
);
